var map = {
	"./helper.js": 1327,
	"./socket.js": 1328,
	"./translation.js": 1329
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1326;


//////////////////
// WEBPACK FOOTER
// ./src/plugins nonrecursive \.js$
// module id = 1326
// module chunks = 1